module.exports = __webpack_public_path__ + "static/media/print-search.fc81c3e9.svg";